import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import Icons from '../../Elements/Icons';
import Loader from '../../Elements/Loader';
import { StyledCheckbox } from '../../Form/Checkbox';
import IconsV2 from '../../V2/Elements/Icons';
import Tooltip from '../../V2/Feedback/Tooltip';
const LoaderWrapper = styled.span `
  margin-left: 5px;
`;
export const StyledLabel = styled.label `
  color: ${({ theme }) => theme.colors.grey100_1};
  font-size: 14px;
  line-height: 16px;
  font-weight: normal;
  align-items: center;
  display: ${({ styled: { isCheckbox } }) => (isCheckbox ? 'inline-flex' : 'flex')};
  margin: ${({ styled: { $margin } }) => $margin};
  ${({ styled: { nowrap } }) => nowrap &&
    css `
      white-space: nowrap;
    `}
  ${({ styled: { type, $margin } }) => type === 'inline-checkbox-inform' &&
    css `
      margin: ${!$margin && '26px 0 0 0'};
      height: 38px;
    `}
  ${({ styled: { isCheckbox, $margin } }) => !isCheckbox &&
    css `
      margin: ${!$margin && '0 0 10px'};
    `}
  ${({ styled: { isCheckbox } }) => isCheckbox &&
    css `
      cursor: pointer;
      *:first-child:not(:last-child) {
        margin-right: 5px;
      }
      &:hover {
        ${StyledCheckbox} {
          border-color: ${({ theme }) => theme.colors.grey70_1};
        }
      }
    `}
`;
export const RequiredMarker = styled.span `
  display: inline-block;
  color: ${({ theme }) => theme.colors.critical100};
  margin-left: 3px;
  width: 6px;

  ::before {
    content: '*';
  }
`;
const TooltipContainer = styled.span `
  display: inline-flex;
  margin: 0 0 0 3px;
`;
const Label = ({ children, required = false, tooltip = null, inline = false, isLoading = false, type, tooltipIcon = 'question', tooltipType = 'tooltip', $margin, nowrap, ...other }) => (_jsxs(StyledLabel, { styled: {
        tooltipIcon,
        required,
        inline,
        isLoading,
        type,
        isCheckbox: type === 'inline-checkbox' || type === 'inline-checkbox-inform',
        $margin,
        nowrap,
    }, ...other, children: [children, required && _jsx(RequiredMarker, {}), isLoading && (_jsx(LoaderWrapper, { children: _jsx(Loader, {}) })), tooltip && (_jsxs(Tooltip, { type: tooltipType, placement: 'top', tooltip: tooltip, ContainerComponent: TooltipContainer, children: [tooltipIcon === 'question' && _jsx(Icons.QuestionCircle, { size: 14 }), tooltipIcon === 'warning' && _jsx(Icons.WarningCircle, { size: 12 }), tooltipIcon === 'info' && _jsx(IconsV2.Info, { filled: true, size: 16 })] }))] }));
export default Label;
